import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AboutUs() {
    const { t } = useTranslation();

    return (
        <>
            <section className="landingPages bg-gray-100 py-16">
                <div className="container mx-auto h-full flex items-center justify-between px-4">
                    <div className="w-full md:w-[48%] flex flex-col">
                        <div className="text-[40px] md:text-[50px] font-bold capitalize text-[#b58630]">
                            {t("About Us")}
                        </div>
                        <div className="font-bold text-[18px] md:text-[20px] capitalize flex items-center gap-[7px] mt-2">
                            <Link to={"/"} className="hover:text-[#b58630] transition-colors">
                                {t("home")}
                            </Link>
                            - <div className="text-[#b58630]">{t("About Us")}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px] bg-white">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-[30px] md:text-[40px] font-bold text-[#b58630] capitalize">
                            {t("Who We Are")}
                        </h2>
                        <p className="text-[16px] md:text-[18px] text-gray-600 mt-4 max-w-2xl mx-auto">
                            {t(
                                "OMA – Where Precision Meets Elegance. Discover a brand that redefines eyewear through science, craftsmanship, and art."
                            )}
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                        <div className="flex justify-center items-center">
                            <img
                                src={require("../../assets/image/1.jpg")}
                                alt="OMA Craftsmanship"
                                className="rounded-lg shadow-lg w-full h-[300px]"
                            />
                        </div>
                        <div className="flex flex-col justify-center">
                            <h3 className="text-[24px] font-semibold text-[#b58630] mb-4">
                                {t("Our Story")}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t(
                                    "At OMA, eyewear is more than a functional accessory — it’s a reflection of your personality and style. Inspired by our core pillars – Optical, Master, Art – we craft each piece to deliver:"
                                )}
                            </p>
                            <ul className="list-disc list-inside text-gray-700 space-y-2">
                                <li>{t("Optical precision with cutting-edge technology")}</li>
                                <li>{t("Masterful craftsmanship in every detail")}</li>
                                <li>{t("Artistic designs that exude elegance")}</li>
                            </ul>
                            <p className="text-gray-700 mt-4">
                                {t(
                                    "OMA is for those who seek eyewear that enhances vision and embodies sophistication."
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="bg-gray-50 py-12 rounded-lg mb-12">
                        <div className="text-center mb-8">
                            <h3 className="text-[24px] font-semibold text-[#b58630]">
                                {t("Our Vision & Mission")}
                            </h3>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 px-4">
                            <div>
                                <h4 className="text-[20px] font-bold text-gray-800 mb-2">
                                    {t("Our Vision")}
                                </h4>
                                <p className="text-gray-600">
                                    {t(
                                        "To lead the world of optics and fashion with innovative, elegant, and reliable eyewear."
                                    )}
                                </p>
                            </div>
                            <div>
                                <h4 className="text-[20px] font-bold text-gray-800 mb-2">
                                    {t("Our Mission")}
                                </h4>
                                <p className="text-gray-600">
                                    {t(
                                        "To deliver a unique eyewear experience through cutting-edge designs that meet visual and aesthetic needs, with a commitment to quality and excellence."
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mb-12">
                        <h3 className="text-[24px] font-semibold text-[#b58630] mb-4">
                            {t("Our Values")}
                        </h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-6">
                            {[
                                {
                                    icon: "🔬",
                                    title: t("Professionalism"),
                                    desc: t("Every product reflects the highest standards of quality and skill."),
                                },
                                {
                                    icon: "🎨",
                                    title: t("Creativity"),
                                    desc: t("We design with an artist’s eye and innovate to stand out."),
                                },
                                {
                                    icon: "🧠",
                                    title: t("Innovation"),
                                    desc: t("We blend advanced technology with modern lifestyle demands."),
                                },
                                {
                                    icon: "👁️",
                                    title: t("Attention to Detail"),
                                    desc: t("Every element, from lens to frame, is crafted to perfection."),
                                },
                            ].map((value, index) => (
                                <div
                                    key={index}
                                    className="p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow"
                                >
                                    <div className="text-[30px] mb-2">{value.icon}</div>
                                    <h4 className="text-[18px] font-semibold text-gray-800 mb-2">
                                        {value.title}
                                    </h4>
                                    <p className="text-gray-600 text-[14px]">{value.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="text-center">
                        <h3 className="text-[24px] font-semibold text-[#b58630] mb-4">
                            {t("Why OMA?")}
                        </h3>
                        <p className="text-gray-600 max-w-2xl mx-auto mb-6">
                            {t(
                                "OMA is the choice for those who see eyewear as more than science — it’s a complete art form that reflects identity and enhances vision."
                            )}
                        </p>
                        <Link
                            to="/collections"
                            className="inline-block bg-[#b58630] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#a57729] transition-colors"
                        >
                            {t("Explore OMA Eyewear")}
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}